/* istanbul ignore file */
import { useState } from 'react';

import { ApolloError } from '@apollo/client';

import { ASNReferenceForPO } from '../../store/types';
import { useService } from '../../store/useService';
import { DEFAULT_TABLE_TOTAL_ROWS } from '../Utils/Utils';
import { SEARCH_PO_ASNS } from './MPNsToReceiveService';

interface useASNPOSearchProps {
  expectedMPN: string;
  referenceId: string;
  onCompleted: (data: ASNReferenceForPO[]) => void;
}

export const useASNPOSearch = ({ onCompleted }: useASNPOSearchProps) => {
  const [asnPos, setAsnPos] = useState([]);
  const [asnPOIndx, setAsnPOIndx] = useState(1);
  const [poAsnError, setPoAsnError] = useState<ApolloError | null>(null);
  const [paginationToken, setPaginationToken] = useState(null);
  const totalPages = Math.ceil(asnPos.length / 20);
  const { useLazyQuery } = useService();

  const [searchAsnPo, { loading, variables, error }] = useLazyQuery(SEARCH_PO_ASNS, {
    fetchPolicy: 'network-only',
    onCompleted: ({ getASNReferences }) => {
      const { asnReferencesList, paginationNextToken } = getASNReferences || {};
      setAsnPos(asnPos.concat(asnReferencesList || []));
      onCompleted(asnReferencesList);
      if (paginationNextToken && asnReferencesList?.length > 0) {
        setPaginationToken(paginationNextToken);
        setAsnPOIndx(totalPages + 1);
      }
    },
    onError: (error: ApolloError) => {
      setPoAsnError(error);
      onCompleted([]);
    },
  });

  const refetchAsns = (indx: number) => {
    if (!paginationToken) {
      return;
    }

    if (indx <= totalPages) {
      setAsnPOIndx(indx);
      return;
    }

    searchAsnPo({
      variables: {
        ...variables,
        paginationToken,
        paginationSize: DEFAULT_TABLE_TOTAL_ROWS,
      },
    });
  };

  return {
    asnPos,
    searchAsnPo,
    setAsnPos,
    error,
    variables,
    asnPOIndx,
    setAsnPOIndx,
    canFetchMore: !!paginationToken,
    refetchAsns,
    asnLoading: loading,
    poAsnError,
  };
};

export default useASNPOSearch;
